import React from 'react';
import { Routes, Route } from "react-router-dom"
import Home from "../Pages/Home"
import Mi from "../Pages/Mi"
import SingleProductPage from "../Pages/SingleProductpage"
import Cart from "../Pages/Cart"
import Apple from "../Pages/Apple."
import SignUp from "../Pages/SignUp"
import Login from "../Pages/Login"
import ProductListing from "../Pages/ProductListing"
import ProductDetails from "../Pages/DynamicProductDetails"
import MainCategorySelection from '../Pages/MainCategorySelection';
import SubCategorySelection from '../Pages/SubCategorySelection';
import Fashion from "../Pages/Categories/Fashion"
import Mobiles from "../Pages/Categories/Mobiles"
import Electronics from "../Pages/Categories/Electronics"
import Beauty from "../Pages/Categories/Beauty"
import HomeDecor from "../Pages/Categories/HomeDecor"
import Appliances from "../Pages/Categories/Appliances"
import Toys from "../Pages/Categories/Toys"
import Grocery from "../Pages/Categories/Grocery"
import Books from "../Pages/Categories/Books"
import Sports from "../Pages/Categories/Sports"
import Orders from "../Pages/Orders"
import Wishlist from "../Pages/Wishlist"
import Settings from "../Pages/Settings"
import TermsAndConditions from "../Pages/TermsAndConditions"
import PrivacyPolicy from "../Pages/PrivacyPolicy"
import RefundPolicy from "../Pages/RefundPolicy"
import FAQ from "../Pages/FAQ"
import '../styles/globals.css';

function AllRoutes() {
    return (
        <Routes>
            <Route path={"/"} element={<Home />} />
            <Route path={"/fashion"} element={<Fashion />} />
            <Route path={"/mobiles"} element={<Mobiles />} />
            <Route path={"/electronics"} element={<Electronics />} />
            <Route path={"/beauty"} element={<Beauty />} />
            <Route path={"/home-decor"} element={<HomeDecor />} />
            <Route path={"/appliances"} element={<Appliances />} />
            <Route path={"/toys"} element={<Toys />} />
            <Route path={"/grocery"} element={<Grocery />} />
            <Route path={"/books"} element={<Books />} />
            <Route path={"/sports"} element={<Sports />} />
            <Route path={"/mi"} element={<Mi />} />
            <Route path={"/singleproductpage/:id"} element={<SingleProductPage />} />
            <Route path={"/cart"} element={<Cart />} />
            <Route path={"/apple"} element={<Apple />} />
            <Route path={"/login"} element={<Login />} />
            <Route path={"/signup"} element={<SignUp />} />
            <Route path={"/products"} element={<ProductListing />} />
            <Route path={"/product/:id"} element={<ProductDetails />} />
            <Route path={"/main-category/:id"} element={<MainCategorySelection />} />
            <Route path={"/category/:id"} element={<SubCategorySelection />} />
            <Route path={"/orders"} element={<Orders />} />
            <Route path={"/wishlist"} element={<Wishlist />} />
            <Route path={"/settings"} element={<Settings />} />
            <Route path={"/terms-and-conditions"} element={<TermsAndConditions />} />
            <Route path={"/terms"} element={<TermsAndConditions />} />
            <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
            <Route path={"/privacy"} element={<PrivacyPolicy />} />
            <Route path={"/refund-policy"} element={<RefundPolicy />} />
            <Route path={"/faq"} element={<FAQ />} />
        </Routes>
    )
}
export default AllRoutes